import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEventAccountMutationVariables = Types.Exact<{
  event_account_id: Types.Scalars['ID'];
  input: Types.UpdateEventAccountInput;
}>;


export type UpdateEventAccountMutation = { __typename?: 'Mutation', updateEventAccount: { __typename?: 'EventAccount', id: string, name?: string | null, description?: string | null, email?: string | null } };


export const UpdateEventAccountDocument = gql`
    mutation UpdateEventAccount($event_account_id: ID!, $input: UpdateEventAccountInput!) {
  updateEventAccount(event_account_id: $event_account_id, input: $input) {
    id
    name
    description
    email
  }
}
    `;
export type UpdateEventAccountMutationFn = Apollo.MutationFunction<UpdateEventAccountMutation, UpdateEventAccountMutationVariables>;

/**
 * __useUpdateEventAccountMutation__
 *
 * To run a mutation, you first call `useUpdateEventAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventAccountMutation, { data, loading, error }] = useUpdateEventAccountMutation({
 *   variables: {
 *      event_account_id: // value for 'event_account_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventAccountMutation, UpdateEventAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventAccountMutation, UpdateEventAccountMutationVariables>(UpdateEventAccountDocument, options);
      }
export type UpdateEventAccountMutationHookResult = ReturnType<typeof useUpdateEventAccountMutation>;
export type UpdateEventAccountMutationResult = Apollo.MutationResult<UpdateEventAccountMutation>;
export type UpdateEventAccountMutationOptions = Apollo.BaseMutationOptions<UpdateEventAccountMutation, UpdateEventAccountMutationVariables>;